module.exports = {"BASE_URL":"https://ppprk.com/mobile/api/index.php","BASE_PCI_URL":"https://passportparking.net/apps/pci/api/index.php"};


// WEBPACK FOOTER //
// external "{/"BASE_URL/":/"https:/ppprk.com/mobile/api/index.php/",/"BASE_PCI_URL/":/"https:/passportparking.net/apps/pci/api/index.php/"}"